<template>
  <div>
      <div
        v-if="!textCopied"
        :class="{'text-copied': textCopied}"
        v-b-popover.hover.right="showTooltip && 'Click to copy'"
        class="click-to-copy"
        v-clipboard:copy="text"
        v-clipboard:success="handledTextCopy"
      >
         {{ text }}
       </div>
      <div v-else style="color: green; font-weight: 800;">
        Copied!!!
      </div>
  </div>
</template>

<script>

export default {
  props: {
    text: String,
    showTooltip: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      textCopied: false,
    }
  },
  methods: {
    handledTextCopy(e) {
      this.textCopied = true
      setTimeout(()=>{
        this.textCopied = false
      }, 2000)
    },
  }
};
</script>

<style scoped>

.click-to-copy {
  cursor: pointer
}

.click-to-copy.text-copied{
  opacity: 0.2;
  background: #a2f1a2;
}


</style>
